export const PRE_QUOTATION_SUBMIT = "@PRE_QUOTATION/SUBMIT";
export const PRE_QUOTATION_SUBMIT_DONE = "@PRE_QUOTATION/SUBMIT_DONE";
